import { useTranslation } from 'react-i18next';
import type { Game } from '../api/types';
import { GameCard } from './GameCard';
import { EmptyState } from './EmptyState';
import { ErrorState } from './ErrorState';

interface Props {
  games: Game[];
  loading: boolean;
  error: string | null;
  emptyMessage?: string | null;
  onRetry?: () => void;
  fundingSource?: 'real' | 'bonus';
}

export function GameGrid({ games, loading, error, emptyMessage, onRetry, fundingSource }: Props) {
  const { t } = useTranslation('games');

  if (loading) {
    return (
      <div className="game-grid" aria-busy="true" aria-label={t('title')}>
        {Array.from({ length: 9 }).map((_, index) => (
          <div key={index} className="skeleton skeleton-card" />
        ))}
      </div>
    );
  }

  if (error) {
    return <ErrorState title={t('errorTitle')} body={error || t('errorBody')} onRetry={onRetry} />;
  }

  if (games.length === 0) {
    return <EmptyState title={t('emptyTitle')} body={emptyMessage || t('emptyBody')} />;
  }

  return (
    <div className="game-grid">
      {games.map((game) => (
        <GameCard key={game.id} game={game} fundingSource={fundingSource} />
      ))}
    </div>
  );
}
